import { Box, Grid, Typography } from "@mui/material";
import BlueMediumButton from "../../../../../../components/customButtons/BlueMediumButton";


export default function NoTestFound({onClick}) {




  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        flexDirection="column"
        gap={2}
        px={{ xs: 2, sm: 5, md: 7, lg: 15 }}
      >
        <Box width={48} height={48}>
          <img src="/PurchaseTest/Group 1171283373 (3).png" />
        </Box>
        <Typography
          textAlign="start"
          color="#572575"
          fontFamily="Inter"
          fontSize="16px"
          lineHeight="100%"
          letterSpacing="0px"
          fontStyle="normal"
          style={{ fontWeight: 700 }}
        >
         No Tests Selected
        </Typography>

        <Typography
          textAlign="center"
          color="#555555"
          fontFamily="Inter"
          fontSize="14px"
          lineHeight="1.4"
          letterSpacing="0px"
          fontStyle="normal"
          style={{ fontWeight: 500 }}
        >
You haven't selected any tests yet. Add tests to proceed with your purchase.        </Typography>

<BlueMediumButton buttonTitle="Browse Available Tests" onClick={onClick}/>
       
      </Box>


      
    </>
  );
}
